module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Western & Atlantic Railroad")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title-head",
    attrs: {
      "id": "Ack"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("From my office, I can hear the whistle of trains operating along the Western & Atlantic Railroad. It is a far cry from the small steam locomotives that ran along the line starting roughly 170 years ago. These are modern diesel-electric engines pulling massive trains packed with a range of goods and commodities. Just as it was back then, the Western & Atlantic is an integral part of so many North Georgia communities.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Writing this book would not have been possible if not for the many museums and research centers dedicated to preserving railroad history for future generations. They are the real heroes. They keep the memory of yesterday’s railroads alive for today’s students of history and those to come tomorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("These museums include the Southern Museum of Civil War & Locomotive History in Kennesaw, Georgia; the Southeastern Railway Museum in Duluth, Georgia; the Adairsville Depot History Museum in Adairsville, Georgia; the Bartow History Museum in Cartersville, Georgia; the Tunnel Hill Heritage Center and Museum in Tunnel Hill, Georgia; the Marietta History Museum in Marietta, Georgia; and the Chattanooga Public Library in Chattanooga, Tennessee.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I am particularly appreciative of the many museums and archivists who provided me with invaluable research assistance. I am even more grateful for my wife, Ruth, for helping me develop this book, and to my parents for helping me proofread drafts and making sure it was at least somewhat coherent.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A book of this nature is not a comprehensive account of everyone associated with the railroad. Nor is it a retelling of every episode, train wreck, and corporate event associated with the line. It is but a brief overview of the Western & Atlantic and its role shaping a region.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-313efe6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgments.vue
// module id = 75
// module chunks = 0